import { isLocaleCA } from '@libs/core';

import { getENV } from './env';

export function getAuth0ClientId(): string {
    return isLocaleCA() ? getENV('NEXT_PUBLIC_AUTH0_CLIENT_ID_CA') : getENV('NEXT_PUBLIC_AUTH0_CLIENT_ID');
}
